import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/reducers/rootReducer'
import selectBrodMigdal from '../../../../generic/utils/selectBrodMigdal'
import { TLikutReasonsMap, filterMishtahCompleteReasons } from './helpers/likutReasons'

const useReasonsLikut = (): TLikutReasonsMap => {
  const [t] = useTranslation('likut')
  const defaults = useSelector((e: RootState) => e.defaults?.defaults)
  // brodMigdal 678: true — משטח קומפלט stays in the deviation reasons; false — hidden.
  // A missing record keeps the reason visible (current behavior until 678 is configured).
  const mishtahCompleteVisible = selectBrodMigdal(defaults, 678, 'Logical_Value') !== false

  const data: TLikutReasonsMap = {
    notExistInAzmana: {
        num: 1,
        tag: t('likut_problem_tag_notExistInAzmana'),
        resons: [
          {id: 5, desc: t('likut_problem_variations_5')},
          {id: 2, desc: t('likut_problem_variations_2')}
        ]
    },
    moreThenNeed: {
        num: 2,
        tag: t('likut_problem_tag_moreThenNeed'),
        resons: [
            {id: 1, desc: t('likut_problem_variations_1')},
            {id: 2, desc: t('likut_problem_variations_2')},
            {id: 6, desc: t('likut_problem_variations_6')}
        ],
    },
    lessThenNeed: {
        num: 3,
        tag: t('likut_problem_tag_lessThenNeed'),
        resons: [
            {id: 1, desc: t('likut_problem_variations_1')},
            {id: 3, desc: t('likut_problem_variations_3')},
            {id: 4, desc: t('likut_problem_variations_4')},
            {id: 2, desc: t('likut_problem_variations_2')},
            {id: 6, desc: t('likut_problem_variations_6')}
        ]
    }
  }
  return filterMishtahCompleteReasons(data, mishtahCompleteVisible)
}

export default useReasonsLikut
